import React from 'react';
import styles from './values.module.css';
import {faHeart, faHome, faLightbulb, faStar, faUsers} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const Values : React.FC = () =>  {

    interface value {

        value: string;
        description: string;
        icon: any;
    }

    const values: value[] = [
        {
            value: "Bienveillance",
            description: "Créer un environnement chaleureux et sécuritaire pour les enfants.",
            icon: faHeart,
        },
        {
            value: "Apprentissage par le jeu",
            description: "Encourager la curiosité et la créativité à travers des activités ludiques et stimulantes.",
            icon: faLightbulb,
        },
        {
            value: "Communauté",
            description: "Bâtir des relations solides avec les familles et la communauté locale.",
            icon: faUsers
        },
        {
            value: "Sentiment d'appartenance",
            description: "Faire en sorte que chaque enfant se sente aimé, valorisé et intégré comme un membre à part entière de notre famille de garderie.",
            icon: faHome
        },
        {
            value: "Confiance",
            description: "Faire confiance aux habiletés parentales et cultiver des liens solides entre les parents, les enfants et notre équipe engagée, solide et stable.",
            icon: faStar
        }
    ];

    const title = "Chez nous, la bienveillance et la chaleur sont au cœur de notre approche. Nous croyons qu’un environnement bienveillant est essentiel pour que les enfants s’épanouissent en" +
        " toute sécurité. Voici nos valeurs fondamentales :"



    return (
        <section className={styles.section_container}>
            <h2 className={styles.section_title}>Nos Valeurs</h2>
            <p className={styles.intro_paragraph}>
                {title}
            </p>
            <ul className={styles.values_list}>
                {values.map((value) => (
                    <li className={styles.value_item}>
                    <FontAwesomeIcon icon={value.icon} className={styles.icon}/>
                    <div>
                        <h3 className={styles.value_title}>{value.value}</h3>
                        <p>{value.description}</p>
                    </div>
                </li>
                ))}
            </ul>
        </section>
    );
};

export default Values;
